<template>
  <v-hover>
    <v-edit-dialog
      slot-scope="{ hover }"
      lazy
      large
      cancel-text="Отмена"
      save-text="Ок"
      @cancel="closeDialog"
      @open="openDialog"
      @save="save"
    >
      <div class="link">
        {{ getStateTitle(editableValue) }}
      </div>
      <div
        v-if="hover"
        class="icon-reveal"
      >
        <v-icon
          class="pb-3 pl-2"
          color="blue darken-2"
          size="13px"
        >
          edit
        </v-icon>
      </div>
      <EnumSelect
        slot="input"
        v-model="editableValue"
        class="mx-2"
        label="Тип поставки*"
        resource="warehouse-details-states"
        :disable-items="editableValue === 4 ? [0, 1, 2, 3, 4] : [0, 2, 3, 4]"
        :disabled="disabled"
      />
    </v-edit-dialog>
  </v-hover>
</template>
<script>
export default {
  props: ["value", "item", "index", "column", "disabled"],
  data() {
    return {
      editableValue: 0,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.editableValue = value;
      },
      immediate: true,
    },
  },
  methods: {
    getStateTitle(stateId) {
      switch (stateId) {
        case 1:
          return "Отдан на свозку";
        case 2:
          return "На складе";
        case 3:
          return "Частично на складе";
        case 4:
          return "Отгружен";
        default:
          return "К свозке";
      }
    },
    openDialog() {
      this.$store.dispatch("oldVersionWarehouseDetails/openDialog", {
        value: this.editableValue,
        rowIndex: this.index,
      });
    },
    closeDialog() {
      this.$store.dispatch("oldVersionWarehouseDetails/closeDialog");
    },
    async save() {
      if (Object.prototype.hasOwnProperty.call(this.item, this.column.name)) {
        this.item[this.column.name] = this.editableValue;
      }
      await this.$store.dispatch("oldVersionWarehouseDetails/save", this.item);
    },
  },
};
</script>
